import * as ErrorActions from '~app/actions/error';
import makeReducer from '~app/core/makeReducer';

const initialState = {
  error: undefined,
  sourceAction: undefined,
};

function setGlobalError(state, {error, sourceAction}) {
  return {
    ...state,
    error,
    sourceAction,
  };
}

function clearGlobalError(state, {error}) {
  if (error !== state.error) return state;
  return {
    ...state,
    error: undefined,
    sourceAction: undefined,
  };
}

const ACTION_HANDLERS = {
  [ErrorActions.SET_GLOBAL_ERROR]: setGlobalError,
  [ErrorActions.CLEAR_GLOBAL_ERROR]: clearGlobalError,
};

export default makeReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/store/errorReducer.js